import { Maybe } from 'maybe-not';
import { sendMessage } from 'q2-tecton-common/lib/utility/message-bus';

export default function clearParams(moduleId: string, platformCapabilties: Set<string>) {
    if (!platformCapabilties.has('clearParams')) {
        return;
    }

    return function(): void {
        sendMessage('clearParams', Maybe.just(JSON.stringify({ moduleId })));
    };
}
